import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RacksRoutingModule } from './racks-routing.module';
import { RacksComponent } from './racks.component';
import { IonicModule } from '@ionic/angular';
import { MatTooltipModule } from "@angular/material";
import {
  MatCheckboxModule,
  MatFormFieldModule,
  MatGridListModule, MatIconModule,
  MatInputModule, MatSelectModule,
  MatTableModule
} from '@angular/material';
import { ReactiveFormsModule } from '@angular/forms';
import { StoreUpdateComponent } from './store-update/store-update.component';
import { NgxMaskModule } from 'ngx-mask';
import {FilterButtonModule} from "../../components/filter-button/filter-button.module";
import {PaginatorComponentModule} from "../../components/paginator/paginator.component.module";

@NgModule({
  declarations: [RacksComponent, StoreUpdateComponent],
  entryComponents: [StoreUpdateComponent],
  imports: [
    CommonModule,
    RacksRoutingModule,
    IonicModule,
    MatTableModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatGridListModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    NgxMaskModule,
    MatSelectModule,
    MatTooltipModule,
    FilterButtonModule,
    PaginatorComponentModule,
  ]
})
export class RacksModule { }
